  <!-- =======================new-hone-page==================================== -->
  <div style="display: inline;">
    <div class="page-layout blank fullwidth" 
      style="overflow-y: auto;height: 1px;
      background: linear-gradient(to right, #FEF7FF, #FFFFFF, #F0F9FF);">
      <!-- ===== CREATE REQUEST SECTION ===== -->
      <div class="asp-home-new">
        <!-- Background bubbles -->
        <!-- <div class="asp-home-new__bg">
          <div class="asp-home-new__circle asp-home-new__circle--one"></div>
          <div class="asp-home-new__circle asp-home-new__circle--two"></div>
          <div class="asp-home-new__circle asp-home-new__circle--three"></div>
        </div>
        <div class="asp-home-new__content">
          <div class="asp-home-new__card">
            <h1 class="asp-home-new__title">✨ Create Request</h1>
            <p class="asp-home-new__subtitle">
              Got a car waiting? Don’t worry — tell us what you need and we will take care of it.
            </p>
            
            <button class="asp-home-new__button" (click)="loadrequest()">🚗 Create New Request ➜</button>
            <ng-template #requestorder></ng-template>
            
          
            <p class="asp-home-new__footer">Create a Request — we’ll handle the rest..</p>

            <div class="asp-home-new__tags">
              <span class="asp-home-new__tag asp-home-new__tag--blue">⏱️ Priority handling</span>
              <span class="asp-home-new__tag asp-home-new__tag--green">🔒 Secure</span>
              <span class="asp-home-new__tag asp-home-new__tag--pink">🎯 Accurate</span>
            </div>
          </div>
        </div> -->
        <!-- ===== FLOATING BUTTON ===== -->
        <div   class="floating-request-btn"
          id="floatingBtn"
          [class.always-visible]="ismobile">
          <div class="floating-request-btn__icon">
            <div class="sparkle sparkle--1">✨</div>
            <div>🛠️</div>
            <div class="sparkle sparkle--2">⚡</div>
          </div>

          <div class="floating-request-btn__text" (click)="loadrequest()">
            <div class="title-with-dots" >
              <strong>Create Request</strong>
              <div class="rotating-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
            <div class="green-title-with-dots">
              <span>Fast & Reliable</span>
              <div class="rotating-dots-green">
                  <span></span><span></span><span></span>
              </div>
            </div>
          </div>

          <span class="floating-request-btn__badge">NEW</span>
        </div>
        <!-- ===== DASHBOARD SECTION BELOW ===== -->
        <!-- <div class="asp-dashboard" *ngIf="hasDashboardData">

          <div class="asp-dashboard__greeting">
            <div class="left">
              <strong>{{ greeting }}, {{spareSelectedGarageName}} 👋</strong>
            </div>
            <div class="right">
              <button class="asp-home-new-button" (click)="loadrequest()">🚗 Create New Request ➜</button>
              <ng-template #requestorder></ng-template>
              <span class="bell">🔔</span>
            </div>
          </div>
          <div class="asp-dashboard__actions" *ngIf="hasDashboardData">
            <button  (click)="loadOrderList()">
              <div class="track-btn">📦</div>
              <div class="track-btn-txt">Track Orders</div>
            </button>
            <button  (click)="loadMakePayment()">
              <div class="pay-btn">💳</div>
              <div class="pay-bt-txt">Make Payment</div>  
            </button>
          </div>
          <div class="asp-dashboard__todo" *ngIf="pendingCount > 0 || totalDues > 0">
            <div class="asp-dashboard__todo-header"  *ngIf="pendingCount > 0 || totalDues > 0">
              <h3><span class="todo-icon" style="color:#4a3500 ;">📋</span> Today's To-Do</h3>
              <span class="pending"  *ngIf="pendingCount > 0">• {{ pendingCount }} pending</span>
            </div>

            <div class="asp-dashboard__todo-item" *ngIf="pendingCount > 0">
              <p>🧾 Quotes awaiting approval: <strong>{{ pendingCount }}</strong></p>
              <button class="review-btn" (click)="goToRequestsByStatus(8)"> Review</button>

            </div>

            <div class="asp-dashboard__todo-item" *ngIf="totalDues > 0">
              <div class="another-p">💰 Total Dues: <strong>₹{{ totalDues | number:'1.2-2' }}</strong></div>

              <button class="paynow-btn"  (click)="loadMakePayment()">Pay Now</button>
            </div>
          </div>
          <div class="asp-dashboard__snapshot" *ngIf="  totalSavings > 0 ||  totalPurchase > 0 || totalOrders > 0 ||   oesPercentage > 0 ">
            <h3>📊 Monthly Snapshot • {{month}}</h3>

            <div class="asp-dashboard__grid">
              <div class="card" *ngIf="totalSavings > 0">
                <p>🎉 Savings</p>
                <h4>{{ totalSavings | number:'1.2-2' }}</h4>
              </div>

              <div class="card" *ngIf="totalPurchase > 0">
                <p>💸 Total Purchase</p>
                <h4>₹{{ totalPurchase | number:'1.2-2' }}</h4>
              </div>

              <div class="card small"  *ngIf="totalOrders > 0">
                <p>📦 Orders</p>
                <h4>{{ totalOrders }}</h4>
              </div>

              <div class="card small" *ngIf="oesPercentage > 0">
                <p>⚙️ OES Share</p>
                <h4>{{ oesPercentage }}%</h4>
              </div>
            </div>
          </div>
          <div class="asp-dashboard__orders"  *ngIf="recentOrdersList?.length > 0">
            <h3>🚛 Recent Orders</h3>

            <div class="order-card" *ngFor="let order of recentOrdersList">
              <div><strong>ORD- {{ order.orderNumber }} • {{ order.registrationNumber }} • ₹{{ order.totalAmount }}</strong>
                <p *ngIf="order.orderStatus && order.orderStatus !== 'draft'">  {{ getOrderStatusText(order.orderStatus) }} 
                  <span *ngIf="order.createdAt"> • ETA: {{ order.createdAt | date:'MMM d' }}</span>
                </p>
              </div>
              <div class="order-footer" *ngIf="order.orderStatus && order.orderStatus !== 'draft'">
                <span class="status-order" [ngClass]="getOrderStatusClass(order.orderStatus)"> {{ getOrderStatusIcon(order.orderStatus) }} {{ order.orderStatus | titlecase }}</span>
                <button (click)="loadorderdetails(order.orderKey)">Track ➜</button>
              </div>
            </div>
          </div>
          <div class="asp-dashboard__requests"  *ngIf="requestProgressList?.length > 0">
            <h3>⚡ Requests in Progress</h3>

            <div class="request-card" *ngFor="let req of requestProgressList">
              <div><strong>REQ-{{ req.requestId }} • {{ formatItemNames(req.itemNames) }}</strong>
              <p>{{ getRequestStatusText(req.status) }}</p>
              <div class="request-footer">
                <span class="status" [ngClass]="getStatusClass(req.status)"> {{ getStatusMessage(buildStatusDetails(req.status)) }}</span>
                <button (click)="navigateToDetails(req.requestId)">Open ➜</button>
              </div>
            </div>
          </div>
          <div class="activity-footer"   *ngIf="totalSavings > 0">
              💡 Great going! You’ve saved <strong>₹{{ totalSavings | number:'1.2-2' }}</strong> this month with <strong>Autoverse</strong>.
          </div>
        </div>
        </div> -->
      <ng-template #orderlistContainer></ng-template>
    <!-- =======================new-hone-page-end==================================== -->
     <div style="width: 100%; display: block;">
        <app-asp-clutch-kit-flow></app-asp-clutch-kit-flow>
      </div>
    <!-- <div class="page-layout blank fullwidth"  style="height: 1px; overflow-y: scroll;    top: 1px;z-index: 99999;"> -->

            <div  [attr.id]="isMobile ? 'vehicleMobile' : 'vehicle'" class="inner-scroll" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="center" >
                <div class="SearchBarContainer" (click)="toggleSearch()" [ngClass]="{'SearchBarContainerMobile': isMobile}" *ngIf="isMobile">
                    <div class="SearchBarButton">
                      <div class="SearchBarIcon">
                        <i class="material-icons">search</i>
                      </div>
                      <div class="SearchBarPlaceholder">
                        <div class="SearchBarAnimation" *ngIf="!isInputVisible">
                          <div id="animationText-1" class="SearchBarAnimationText">Search By "Part Name"</div>
                          <div id="animationText-2" class="SearchBarAnimationText">Search By "Part Number"</div>
                          <div id="animationText-3" class="SearchBarAnimationText">Search By "Brand"</div>
                          <div id="animationText-4" class="SearchBarAnimationText">Search By "Category"</div>
                        </div>
                  
                        <div *ngIf="isInputVisible" class="SearchInputContainer" (click)="$event.stopPropagation()">
                            <input
                              type="text"
                              placeholder="Type your search"
                              class="SearchInput"
                              [(ngModel)]="searchText"
                              (input)="filterSuggestions()"
                              (click)="toggleSearch()"
                            >
                            <button (click)="clearSearch($event)" class="button">
                              <i class="material-icons" style="font-size: 16px;">clear</i>
                            </button>
                    
                            <!-- Suggestions Dropdown -->
                            <div #dropdown class="suggestions" *ngIf="suggestions.length > 0">
                              <div *ngFor="let suggestion of suggestions; let i = index" (click)="selectSuggestion(suggestion)">
                                <i class="material-icons" *ngIf="isFirstSuggestion(suggestion,i)" style="font-size: 14px; padding: 10px;">access_time</i>
                                <i class="material-icons" *ngIf="!isFirstSuggestion(suggestion,i)" style="font-size: 14px; padding: 10px;">search</i>
                                <span [innerHTML]="getHighlightedText(suggestion.value, searchText)"></span>

                              </div>
                            </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
            
            <div id="vehicle-intro" fxFlex>
                
                <div class="title" [@animate]="{value:'*',params:{delay:'650ms',y:'25px'}}" [ngClass]="{'titleMobile': isMobile}">
                    Welcome to  The <strong>  Universe of Auto Parts</strong>
                </div>
                <div class="description" [@animate]="{value:'*',params:{delay:'700ms',y:'25px'}}">
                    
                    <strong>Timely delivery of genuine spare parts, every time!</strong>
                </div>
            </div>
            <div id="vehicle-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}" [ngClass]="{'is-make': !vehicleInfo}">
            <div id="vehicle-form" *ngIf="!vehicleInfo" style="margin-top: 2%;width: 100%;">
                <form [class.loading]="loading" name="vehicleForm" [formGroup]="vehicleForm" (ngSubmit)="onSubmit()" novalidate>
                    <div class="enter">
                        <mat-label for="regNo">Enter your car number</mat-label>
                    </div>

                    <!-- Google Analytics -->
                    <!-- <button (click)="onButtonClick()">Click Me</button> -->
                    <!-- End Google Analytics -->

                    <mat-form-field appearance="outline" style="font-size: larger;">
                        <div style="display: flex; align-items: center;">
                            <div class="left-section"  >
                                <img src="../../../../assets/images/home-page-reg-number/Group 16(1).png" alt="Car" width="18" height="10">
                                <span class="ind" >IND</span>
                            </div>
                            <div style="border-right: 1px solid #dddddd;height: 20px;width: 2px;    margin-top: 4px;"></div>
                            <div class="registration-number">
                                <input id="regNo" matInput formControlName="regNo" autocomplete="off" placeholder="KA 01 MY97**" maxlength="13" style="font-weight: 600; width: 98%;">
                            </div>
                            
                        </div>
                        <mat-error *ngIf="vehicleForm.get('regNo').hasError('required')">
                            Registration Number is required
                        </mat-error>
                    </mat-form-field>
                    <button mat-raised-button color="accent" class="submit-button" aria-label="VEHICLE" [disabled]="vehicleForm.invalid">
                        FIND MY CAR
                    </button>
                </form>

                <div class="separator" [ngClass]="{'separatorMobile': isMobile}">
                    <span class="text">Or</span>
                </div>

                <h4 class="text-center" [ngClass]="{'text-centerMobile': isMobile}" (click)="goToMake()">Enter car details manually</h4>
                <div *ngIf="isOpenMake">
                    <div [ngClass]="{'popularMMobile': isMobile}">
                    <div class="popularMakes" *ngFor="let make of makeList" (click)="selectMake(make.make)">
                        <img class="img-fluid make-image" src="{{make.imageUrlPath}}" alt="" />
                    </div>
                </div >
                    <div class="popularMakes viewAll" style="padding: 24px 10px;" (click)="goToMake()">
                        View All
                    </div>
                </div>
                <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
            </div>

            <div [attr.id]="isMobile ? 'vehicle-infoMobile' : 'vehicle-info'" *ngIf="vehicleInfo"  #popupSection>
                <!-- <mat-icon class="car-icon">directions_car</mat-icon> -->
                <div class="logo-container">
                    <img src="../../../../assets/images/logos/mobile_autoverse_logo.svg" alt="Autoverse Logo">
                    <p><strong>AUTOVERSE</strong></p>
                    <img src="../../../../assets/images/share.png" alt="Share" (click)="shareDetails()" style="left: 28%;position: relative; cursor: pointer;">
                </div>
                <p class="registration-number">{{vehicleData.registrationNumber}}</p>
                <!-- <h3>Confirm your car details</h3> -->
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>Make</div>
                    <div class="right">{{vehicleData.make}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>Model</div>
                    <div class="right">{{vehicleData.model}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>Variant</div>
                    <div class="right">{{vehicleData.variant}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>MFG Year</div>
                    <div class="right">{{vehicleData.year}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>Fuel</div>
                    <div class="right">{{vehicleData.fuel}}</div>
                </div>
                <div class="vehicle-details-row">
                    <div class="left"><mat-icon>check_circle</mat-icon>VIN</div>
                    <div class="right">{{vehicleData.vin}}</div>
                </div>
                  <div class="vehicle-details-row" *ngIf="vehicleData?.generation">
                    <div class="left"><mat-icon>check_circle</mat-icon>Generation</div>
                    <div class="right">{{vehicleData.generation}}</div>
                </div>
                  <div class="vehicle-details-row" *ngIf="vehicleData?.vehicleType">
                    <div class="left"><mat-icon>check_circle</mat-icon>Vehicle Type</div>
                    <div class="right">{{vehicleData.vehicleType}}</div>
                </div>


                <button mat-raised-button color="accent" class="confirm-btn" aria-label="Confirm" (click)="confirmCar()">
                    Confirm
                </button>
                <button mat-raised-button color="accent" class="change-car-button" aria-label="Change Car" (click)="changeCar()">
                    Change Car
                </button>
            </div>
        </div>
        </div>
        <div class="banners-container" (pointerdown)="stopAutoScroll()">
            <mat-icon class="scroll-button left" (click)="scrollLeft()">keyboard_arrow_left</mat-icon>
              <!-- <button >&lt;</button> -->
              <div class="banners">

                  <img class="bumper-banner" (click)="categoryBanner()" src="../../../../assets/images/banners/Bumper.jpg">
                  <img class="bumper-banner" (click)="Head_Lamp_1()" src="../../../../assets/images/banners/Head_Lamp_1.jpg">
                  <img class="bumper-banner" (click)="brandBanner()" src="../../../../assets/images/banners/Bosch_Wiper_Blades 1.jpg">
                  <img class="bumper-banner" (click)="Purolator_Filters()" src="../../../../assets/images/banners/Purolator_Filters_2.jpg">
                  <img class="bumper-banner" (click)="Floron_AC_Gas()" src="../../../../assets/images/banners/Floron_AC_Gas.jpg">
                  <img class="bumper-banner" (click)="Hella_Coolant_Premium1()" src="../../../../assets/images/banners/Hella_Coolant_Premium1.jpg"> 
                  <img class="bumper-banner" (click)="Maruti_Suzuki_Clutch_Release()" src="../../../../assets/images/banners/Maruti_Suzuki's_Clutch_Release_Bearing_2.jpg">
                  <img class="bumper-banner" (click)="NGK_Spark_Plugs_1()" src="../../../../assets/images/banners/NGK_Spark_Plugs_1.jpg">
                  <img class="bumper-banner" (click)="TVS_Girling_Brake_Pads_1()" src="../../../../assets/images/banners/TVS_Girling_Brake_Pads_1.jpg">
                  <img class="bumper-banner" (click)="Zip_AC_Filters()" src="../../../../assets/images/banners/Zip_AC_Filters!.jpg">
                  
              </div>
            <mat-icon class="scroll-button right" (click)="scrollRight()">keyboard_arrow_right</mat-icon>
            <!-- <button >&gt;</button> -->
        </div>
        <!-- <mat-card class="mat-elevation-z8 mt-8 p-8 home p-12"  >
            <mat-card-header>
                <mat-card-title  >Shop By Categories</mat-card-title>
            </mat-card-header>

            <mat-card-content>
                <div *ngIf="veiwMoreCat" fxLayout="column" fxLayout.xs="column" style="padding: 10px;">
                    <div fxLayout="row wrap" fxLayoutGap="10px">
                       <div fxFlex="23.7%" [ngClass]="{'CategoriesInsideMobile': isMobile}">
                            <mat-card (click)="openVehiclePopup()">
                                <img src="../../../../assets/images/service-kit-img/ser-kit-prd-dtl-img.jpeg"
                                    [ngClass]="{'CategoriesImgMobile': isMobile}"
                                    alt="Service Kit">
                                <div class="cat_name" [ngClass]="{'cat_nameMobile': isMobile}">
                                    Service Kits
                                </div>
                            </mat-card>
                        </div>
                        <div *ngFor="let cat of categories; let i = index" fxFlex="23.7%" [ngClass]="{'CategoriesInsideMobile': isMobile}">
                            <mat-card *ngIf="i <= 7" (click)="sparesList(cat.name, 'categorySpares')">
                                <img src="{{cat.imageUrl}}"  [ngClass]="{'CategoriesImgMobile': isMobile}" alt="">
                                <div class="cat_name"  [ngClass]="{'cat_nameMobile': isMobile}">{{cat.name}}</div>
                            </mat-card>
                        </div>
                    </div>
                    <button mat-button (click)="getAllCategories()" class="view-more-cat" [ngClass]="{'view-more-catMobile': isMobile}">View More</button>
                </div>
                

                <div *ngIf="veiwLessCat" fxLayout="column" fxLayout.xs="column" style="padding: 10px;">
                    <div fxLayout="row wrap" fxLayoutGap="10px">
                        <div *ngFor="let cat of allCategories; let i = index" fxFlex="23.7%" [ngClass]="{'CategoriesInsideMobile': isMobile}">
                            <mat-card (click)="sparesList(cat.name, 'categorySpares')">
                                <img src="{{cat.imageUrl}}" [ngClass]="{'CategoriesImgMobile': isMobile}" alt="">
                                <div class="cat_name" [ngClass]="{'cat_nameMobile': isMobile}">{{cat.name}}</div>
                            </mat-card>
                        </div>
                    </div>
                    <button mat-button (click)="viewLessBrands()" class="view-less-cat" [ngClass]="{'view-less-catMobile': isMobile}">View Less</button>
                </div>
            </mat-card-content>
        </mat-card> -->
        <div class="pcat-section">
            <mat-card class="pcat-card mat-elevation-z0">

                <div class="pcat-header">
                  <div class="pcat-heading-block">
                    <div class="pcat-title">Shop By Categories</div>
                      <div class="pcat-subtitle">{{ categoryCount || 0 }} Categories Available</div>
                    </div>

                     <span *ngIf="veiwMoreCat"
                            mat-button
                            (click)="getAllCategories()"
                            class="pcat-view-more-btn"
                            [ngClass]="{'pcat-view-more-btn-mobile': isMobile}">
                        <div>View More</div>
                        <mat-icon>arrow_forward</mat-icon>
                    </span>

                    <span *ngIf="veiwLessCat"
                            mat-button
                            (click)="viewLessBrands()"
                            class="pcat-view-less-btn"
                            [ngClass]="{'pcat-view-less-btn-mobile': isMobile}">
                        <div>View Less</div>
                         <mat-icon>arrow_forward</mat-icon>
                    </span>
                    
                </div>

                <mat-card-content class="pcat-content">

                    <!-- default view (view more) -->
                    <div *ngIf="veiwMoreCat">
                        <div class="pcat-grid">
                            <div class="pcat-col" [ngClass]="{'pcat-col-mobile': isMobile}">
                                <div class="pcat-item" (click)="openVehiclePopup()">
                                    <div class="pcat-logo-box">
                                        <img src="../../../../assets/images/service-kit-img/ser-kit-prd-dtl-img.jpeg"
                                            class="pcat-logo-img"
                                            [ngClass]="{'pcat-logo-img-mobile': isMobile}"
                                            alt="Service Kit">
                                    </div>
                                    <div class="pcat-name" [ngClass]="{'pcat-name-mobile': isMobile}">
                                        Service Kits
                                    </div>
                                </div>
                            </div>

                            <div *ngFor="let cat of categories; let i = index"
                                class="pcat-col"
                                [ngClass]="{'pcat-col-mobile': isMobile}">
                                <div *ngIf="i <= 7"
                                    class="pcat-item"
                                    (click)="sparesList(cat.name, 'categorySpares')">
                                    <div class="pcat-logo-box">
                                        <img src="{{cat.imageUrl}}"
                                            class="pcat-logo-img"
                                            [ngClass]="{'pcat-logo-img-mobile': isMobile}"
                                            alt="{{cat.name}}">
                                    </div>
                                    <div class="pcat-name" [ngClass]="{'pcat-name-mobile': isMobile}">{{cat.name}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="pcat-btn-wrapper">
                            <button mat-button
                                    (click)="getAllCategories()"
                                    class="pcat-view-more-btn"
                                    [ngClass]="{'pcat-view-more-btn-mobile': isMobile}">
                                View More
                            </button>
                        </div>
                    </div>

                    <!-- expanded view (view less) -->
                    <div *ngIf="veiwLessCat">
                        <div class="pcat-grid">
                            <div *ngFor="let cat of allCategories; let i = index"
                                class="pcat-col"
                                [ngClass]="{'pcat-col-mobile': isMobile}">
                                <div class="pcat-item" (click)="sparesList(cat.name, 'categorySpares')">
                                    <div class="pcat-logo-box">
                                        <img src="{{cat.imageUrl}}"
                                            class="pcat-logo-img"
                                            [ngClass]="{'pcat-logo-img-mobile': isMobile}"
                                            alt="{{cat.name}}">
                                    </div>
                                    <div class="pcat-name" [ngClass]="{'pcat-name-mobile': isMobile}">{{cat.name}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="pcat-btn-wrapper">
                            <button mat-button
                                    (click)="viewLessBrands()"
                                    class="pcat-view-less-btn"
                                    [ngClass]="{'pcat-view-less-btn-mobile': isMobile}">
                                View Less
                            </button>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
        <!-- <img class="banner-img" (click)="loadorderdetails()" src="../../../../assets/images/banner_spare-kit.jpg"> -->

        <!-- <mat-card class="mat-elevation-z8 mt-8 p-8 home p-12" >
            <mat-card-header>
                <mat-card-title >Popular Brands</mat-card-title>
                <span class="view-all-brands" (click)="goToAllBrands()">View All</span>
            </mat-card-header>

            <mat-card-content>
                <div fxLayout="column" fxLayout.xs="column" style="padding: 10px;">
                    <div fxLayout="row wrap" fxLayoutGap="10px">
                        <div *ngFor="let brand of brands; let i = index" fxFlex="23.7%" [ngClass]="{'CategoriesInsideMobile': isMobile}">                        
                            <mat-card *ngIf="i<=7" (click)="sparesList(brand.name, 'brandSpares', brand.imageUrl,brand.key)">
                                <img src="{{brand.imageUrl}}" [ngClass]="{'CategoriesImgMobile': isMobile}" alt="">
                                <div class="brand_name" [ngClass]="{'cat_nameMobile': isMobile}">{{brand.name}}</div>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card> -->
        <div class="pbr-section">
            <mat-card class="pbr-card mat-elevation-z0">

                <div class="pbr-header">
                    <div class="pbr-heading-block">
                        <div class="pbr-title">Popular Brands</div>
                        <div class="pbr-subtitle"> {{ brandCount }} Brands Available </div>
                    </div>
                    <span class="pbr-view-all" (click)="goToAllBrands()">
                        View All 
                        <!-- <span class="pbr-arrow">&#8594;</span> -->
                         <mat-icon>arrow_forward</mat-icon>
                    </span>
                </div>

                <mat-card-content class="pbr-content">
                    <div class="pbr-grid">
                        <div *ngFor="let brand of brands; let i = index"
                            class="pbr-col"
                            [ngClass]="{'pbr-col-mobile': isMobile}">
                            <div *ngIf="i<=7"
                                class="pbr-item"
                                (click)="sparesList(brand.name, 'brandSpares', brand.imageUrl, brand.key)">
                                <div class="pbr-logo-box">
                                    <img src="{{brand.imageUrl}}"
                                        class="pbr-logo-img"
                                        [ngClass]="{'pbr-logo-img-mobile': isMobile}"
                                        alt="{{brand.name}}">
                                </div>
                                <div class="pbr-name" [ngClass]="{'pbr-name-mobile': isMobile}">{{brand.name}}</div>
                                <span class="pbr-tag" *ngIf="brand.tag">{{brand.tag}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="pbr-btn-wrapper">
                        <button mat-raised-button class="pbr-view-all-btn" (click)="goToAllBrands()">
                            View All Brands
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="bokeh-background" *ngIf="magicPopup">
          <div class="popup-card animate-popup">
            <button class="close-btn" (click)="close()">×</button>

            <h2>Autoverse</h2>
            <p>Ready for some magic? ✨</p>

            <button class="magic-btn animate-cta" (click)="loadInstantDetails()">
              ✨ Get Magic Quote ✨
            </button>

            <p class="sub-text">Experience the most magical car quote system ever created</p>
          </div>
        </div>

        <!-- AUTOVERSE STORE SECTION -->
        <div class="avx-store-section"  *ngIf="brandSparesList?.length > 0">
          <div class="avx-store-header">
            <div class="avx-store-title-wrap">
              <div class="avx-store-logo">
                <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="64" height="64" rx="9.1" fill="white"/>
                  <rect x="0.5" y="0.5" width="64" height="64" rx="9.1" stroke="#C8E4FF"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M38.7176 25.1733C38.7176 25.2126 38.7176 25.2506 38.7176 25.2887C38.3878 25.4566 38.0816 25.6485 37.7443 25.8088C37.7782 26.2234 37.7847 26.6948 37.7443 27.1077C38.0595 27.3283 38.4018 27.5214 38.7176 27.742C38.7176 27.7519 38.7176 27.7622 38.7176 27.7721C38.6553 27.967 38.6108 28.1801 38.5502 28.3785C38.1935 28.3628 37.7796 28.4083 37.4659 28.3481C37.251 28.7332 37.0926 29.1739 36.8253 29.5026C37.0291 29.8304 37.2192 30.1727 37.4094 30.5124C37.3061 30.7128 37.1173 30.8254 36.9928 31.0044C36.6551 30.8347 36.3247 30.6572 36.0195 30.4563C35.6797 30.7099 35.3501 30.9721 34.9626 31.177C34.9699 31.5807 35.0299 31.9324 35.0171 32.3616C34.8416 32.4372 34.6584 32.5073 34.4624 32.5622C34.192 32.3028 34.0072 31.9553 33.8218 31.6106C33.4441 31.699 33.0553 31.7754 32.5691 31.7552C32.405 32.1129 32.2613 32.4916 32.0973 32.8512C31.8844 32.8307 31.6616 32.8205 31.485 32.7651C31.4082 32.4194 31.361 32.0464 31.3458 31.6388C31.142 31.5618 30.9292 31.4931 30.7052 31.4356C30.8542 31.0221 30.9952 30.6025 31.1511 30.1953C33.935 31.0892 36.6874 29.1992 36.4927 26.1841C36.3521 24.0274 34.5984 22.5299 32.6528 22.4891C30.5341 22.4454 28.4681 24.1512 28.6193 26.675C28.6851 27.7666 29.0626 28.3694 29.6208 29.1574C29.4768 29.2371 29.3283 29.416 29.1478 29.5891C29.0406 29.6928 28.767 30.0226 28.703 30.0226C28.5508 30.0226 28.4112 29.5385 28.2572 29.5026C27.8967 29.5895 27.5331 29.6743 27.1446 29.7336C27.0755 29.5471 26.9612 29.4049 26.8945 29.2133C27.0248 28.9061 27.4249 28.6301 27.7014 28.3785C27.5523 28.0108 27.4398 27.6093 27.3948 27.1357C27.0433 26.9904 26.6448 26.8954 26.2822 26.7613C26.2822 26.5496 26.2822 26.3378 26.2822 26.126C26.6272 26.0031 27.0008 25.9106 27.3948 25.838C27.4355 25.36 27.5379 24.9466 27.7014 24.5963C27.4517 24.2686 27.1014 24.0456 26.8945 23.6729C27.0234 23.5187 27.0655 23.273 27.2284 23.154C27.5762 23.2448 27.9286 23.3312 28.2572 23.4421C28.5234 23.0832 28.8517 22.7894 29.1196 22.4323C29.0013 22.0936 28.8929 21.7447 28.8139 21.3641C28.9374 21.1944 29.1476 21.114 29.3142 20.9887C29.6232 21.2262 29.865 21.534 30.1766 21.7687C30.5137 21.5593 30.9371 21.4396 31.3456 21.3059C31.3909 20.8919 31.4443 20.4852 31.5686 20.1516C31.7573 20.1264 31.929 20.0837 32.1527 20.0945C32.3067 20.4243 32.4165 20.801 32.542 21.1625C32.971 21.1991 33.4316 21.2014 33.7654 21.335C34.0582 21.053 34.211 20.623 34.544 20.3825C34.702 20.4886 34.9486 20.5036 35.0737 20.6425C35.0499 21.0226 35.0027 21.3773 34.9627 21.7396C35.3342 21.9777 35.6834 22.2408 36.047 22.4894C36.3261 22.2793 36.6809 22.1477 37.0203 21.9996C37.1761 22.1463 37.3454 22.2788 37.4389 22.4894C37.2443 22.8167 37.0332 23.129 36.8256 23.4421C37.0793 23.7757 37.2758 24.1683 37.4389 24.5965C37.8284 24.5876 38.1932 24.6024 38.5505 24.6256C38.6432 24.7704 38.6477 25.0054 38.7176 25.1733Z" fill="#144579"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M28.0077 33.8329C27.999 33.8329 27.9893 33.8329 27.9795 33.8329C27.8295 33.7004 27.614 33.6337 27.5075 33.4576C27.6047 33.078 27.7527 32.7508 27.8685 32.3894C27.72 32.2252 27.5281 32.1082 27.4238 31.8977C27.5955 31.7879 27.6874 31.6365 27.8685 31.466C27.9453 31.3942 28.2372 31.0534 28.3416 31.0627C28.3473 31.063 28.6269 31.3363 28.6754 31.3798C29.0658 31.7198 29.459 31.9665 29.9 32.1587C29.7335 32.5351 29.6277 32.9729 29.4542 33.341C29.259 33.2654 29.052 33.202 28.8984 33.0819C28.5922 33.3235 28.3091 33.5853 28.0077 33.8329Z" fill="#F2F9FF"/>
                  <path d="M11.1805 42.9072C11.1174 42.7007 11.0457 42.4885 10.9654 42.2705C10.8908 42.0526 10.8163 41.8346 10.7417 41.6166H8.41866C8.3441 41.8346 8.26666 42.0526 8.18636 42.2705C8.11179 42.4885 8.04296 42.7007 7.97987 42.9072H6.58604C6.80974 42.2648 7.02197 41.6711 7.22273 41.1262C7.42348 40.5813 7.6185 40.0679 7.80779 39.5861C8.00281 39.1043 8.1921 38.6483 8.37564 38.2181C8.56493 37.7822 8.75995 37.3577 8.96071 36.9447H10.2427C10.4377 37.3577 10.6299 37.7822 10.8191 38.2181C11.0084 38.6483 11.1977 39.1043 11.387 39.5861C11.582 40.0679 11.7799 40.5813 11.9807 41.1262C12.1814 41.6711 12.3937 42.2648 12.6174 42.9072H11.1805ZM9.57158 38.2955C9.5429 38.3816 9.49988 38.4992 9.44253 38.6483C9.38517 38.7974 9.3192 38.9695 9.24464 39.1645C9.17007 39.3596 9.0869 39.5747 8.99512 39.8098C8.90908 40.045 8.82018 40.2916 8.7284 40.5498H10.4234C10.3316 40.2916 10.2427 40.045 10.1566 39.8098C10.0706 39.5747 9.98744 39.3596 9.90713 39.1645C9.83257 38.9695 9.7666 38.7974 9.70925 38.6483C9.65189 38.4992 9.606 38.3816 9.57158 38.2955ZM15.5528 43.0277C15.134 43.0277 14.7727 42.9703 14.4687 42.8556C14.1647 42.7351 13.9123 42.5717 13.7115 42.3652C13.5165 42.153 13.3702 41.9034 13.2727 41.6166C13.181 41.3241 13.1351 41.0029 13.1351 40.653V36.9447H14.4773V40.5412C14.4773 40.7821 14.5031 40.9886 14.5547 41.1606C14.6121 41.327 14.6866 41.4646 14.7784 41.5736C14.8759 41.6769 14.9906 41.7514 15.1226 41.7973C15.2602 41.8432 15.4094 41.8662 15.57 41.8662C15.8969 41.8662 16.1608 41.7658 16.3615 41.565C16.568 41.3643 16.6713 41.023 16.6713 40.5412V36.9447H18.0135V40.653C18.0135 41.0029 17.9647 41.3241 17.8672 41.6166C17.7697 41.9092 17.6206 42.1616 17.4198 42.3738C17.219 42.5803 16.9638 42.7409 16.6541 42.8556C16.3443 42.9703 15.9772 43.0277 15.5528 43.0277ZM23.7267 36.9447V38.0891H21.9285V42.9072H20.5863V38.0891H18.7881V36.9447H23.7267ZM25.5148 39.9217C25.5148 40.2142 25.5492 40.4781 25.618 40.7132C25.6926 40.9484 25.7958 41.152 25.9277 41.3241C26.0654 41.4905 26.2318 41.6195 26.4268 41.7113C26.6218 41.8031 26.8455 41.849 27.0979 41.849C27.3445 41.849 27.5654 41.8031 27.7604 41.7113C27.9611 41.6195 28.1275 41.4905 28.2594 41.3241C28.3971 41.152 28.5003 40.9484 28.5691 40.7132C28.6437 40.4781 28.681 40.2142 28.681 39.9217C28.681 39.6292 28.6437 39.3653 28.5691 39.1301C28.5003 38.8892 28.3971 38.6856 28.2594 38.5193C28.1275 38.3472 27.9611 38.2152 27.7604 38.1235C27.5654 38.0317 27.3445 37.9858 27.0979 37.9858C26.8455 37.9858 26.6218 38.0346 26.4268 38.1321C26.2318 38.2239 26.0654 38.3558 25.9277 38.5279C25.7958 38.6942 25.6926 38.8978 25.618 39.1387C25.5492 39.3739 25.5148 39.6349 25.5148 39.9217ZM30.0662 39.9217C30.0662 40.4322 29.9888 40.8824 29.8339 41.2725C29.6848 41.6568 29.4783 41.9809 29.2144 42.2447C28.9506 42.5028 28.6351 42.6979 28.268 42.8298C27.9066 42.9617 27.5166 43.0277 27.0979 43.0277C26.6906 43.0277 26.3063 42.9617 25.945 42.8298C25.5836 42.6979 25.2681 42.5028 24.9985 42.2447C24.7289 41.9809 24.5167 41.6568 24.3618 41.2725C24.207 40.8824 24.1295 40.4322 24.1295 39.9217C24.1295 39.4112 24.2098 38.9638 24.3704 38.5795C24.5311 38.1894 24.7462 37.8625 25.0157 37.5986C25.2911 37.3348 25.6065 37.1369 25.9622 37.005C26.3235 36.873 26.7021 36.8071 27.0979 36.8071C27.5051 36.8071 27.8894 36.873 28.2508 37.005C28.6122 37.1369 28.9276 37.3348 29.1972 37.5986C29.4668 37.8625 29.679 38.1894 29.8339 38.5795C29.9888 38.9638 30.0662 39.4112 30.0662 39.9217ZM32.739 42.9072C32.5038 42.4082 32.2715 41.8891 32.0421 41.3499C31.8126 40.8107 31.5947 40.2773 31.3882 39.7496C31.1817 39.2219 30.9895 38.7171 30.8117 38.2353C30.6396 37.7535 30.4905 37.3233 30.3643 36.9447H31.8442C31.9589 37.2889 32.0822 37.6617 32.2142 38.0632C32.3518 38.459 32.4895 38.8548 32.6271 39.2506C32.7705 39.6464 32.9082 40.0249 33.0401 40.3863C33.1721 40.7477 33.2954 41.0603 33.4101 41.3241C33.5191 41.0603 33.6395 40.7477 33.7715 40.3863C33.9091 40.0249 34.0468 39.6464 34.1844 39.2506C34.3278 38.8548 34.4655 38.459 34.5974 38.0632C34.7351 37.6617 34.8613 37.2889 34.976 36.9447H36.4042C36.2723 37.3233 36.1203 37.7535 35.9482 38.2353C35.7762 38.7171 35.5869 39.2219 35.3804 39.7496C35.1739 40.2773 34.9559 40.8107 34.7265 41.3499C34.4971 41.8891 34.2647 42.4082 34.0296 42.9072H32.739ZM37.1758 42.9072V36.9447H41.2024V38.0718H38.518V39.242H40.9013V40.3433H38.518V41.7801H41.4003V42.9072H37.1758ZM44.1402 36.8759C45.035 36.8759 45.7204 37.0365 46.1965 37.3577C46.6726 37.6732 46.9107 38.1665 46.9107 38.8376C46.9107 39.2563 46.8131 39.5976 46.6181 39.8615C46.4288 40.1196 46.1535 40.3232 45.7921 40.4723C45.9126 40.6215 46.0388 40.7935 46.1707 40.9886C46.3026 41.1778 46.4317 41.3786 46.5579 41.5908C46.6898 41.7973 46.816 42.0153 46.9365 42.2447C47.0569 42.4684 47.1688 42.6893 47.272 42.9072H45.7663C45.6574 42.7122 45.5455 42.5143 45.4308 42.3136C45.3218 42.1128 45.2071 41.9178 45.0866 41.7285C44.9719 41.5392 44.8572 41.3614 44.7425 41.1951C44.6278 41.023 44.513 40.8681 44.3983 40.7304H43.7358V42.9072H42.3936V37.0308C42.6861 36.9734 42.9873 36.9333 43.297 36.9103C43.6125 36.8874 43.8936 36.8759 44.1402 36.8759ZM44.2176 38.0202C44.1201 38.0202 44.0312 38.0231 43.9509 38.0288C43.8764 38.0346 43.8047 38.0403 43.7358 38.046V39.6636H44.1144C44.6192 39.6636 44.9805 39.6005 45.1985 39.4743C45.4164 39.3481 45.5254 39.133 45.5254 38.829C45.5254 38.5365 45.4136 38.33 45.1899 38.2095C44.9719 38.0833 44.6478 38.0202 44.2176 38.0202ZM49.7585 41.8834C49.9478 41.8834 50.1026 41.869 50.2231 41.8403C50.3493 41.8059 50.4496 41.7629 50.5242 41.7113C50.5988 41.6539 50.6504 41.588 50.6791 41.5134C50.7078 41.4388 50.7221 41.3557 50.7221 41.2639C50.7221 41.0689 50.6303 40.9083 50.4468 40.7821C50.2632 40.6501 49.9478 40.5096 49.5003 40.3605C49.3053 40.2916 49.1103 40.2142 48.9153 40.1282C48.7203 40.0364 48.5453 39.9246 48.3904 39.7926C48.2356 39.655 48.1094 39.4915 48.0119 39.3022C47.9144 39.1072 47.8656 38.872 47.8656 38.5967C47.8656 38.3214 47.9172 38.0747 48.0205 37.8568C48.1237 37.6331 48.27 37.4438 48.4593 37.2889C48.6486 37.134 48.878 37.0164 49.1476 36.9361C49.4172 36.8501 49.7212 36.8071 50.0596 36.8071C50.4611 36.8071 50.8081 36.8501 51.1007 36.9361C51.3932 37.0222 51.6341 37.1168 51.8234 37.2201L51.4362 38.2783C51.2699 38.1923 51.0835 38.1177 50.877 38.0546C50.6762 37.9858 50.4324 37.9514 50.1456 37.9514C49.8244 37.9514 49.5921 37.9973 49.4487 38.0891C49.3111 38.1751 49.2422 38.3099 49.2422 38.4934C49.2422 38.6024 49.268 38.6942 49.3197 38.7688C49.3713 38.8433 49.443 38.9122 49.5348 38.9753C49.6323 39.0326 49.7413 39.0871 49.8617 39.1387C49.9879 39.1846 50.1256 39.2334 50.2747 39.285C50.5844 39.3997 50.854 39.5144 51.0835 39.6292C51.3129 39.7381 51.5022 39.8672 51.6513 40.0163C51.8062 40.1655 51.9209 40.3404 51.9955 40.5412C52.07 40.7419 52.1073 40.9857 52.1073 41.2725C52.1073 41.8289 51.9123 42.2619 51.5223 42.5717C51.1322 42.8757 50.5443 43.0277 49.7585 43.0277C49.4946 43.0277 49.2566 43.0105 49.0443 42.9761C48.8321 42.9474 48.6428 42.9101 48.4765 42.8642C48.3159 42.8183 48.1754 42.7696 48.0549 42.7179C47.9402 42.6663 47.8427 42.6176 47.7624 42.5717L48.1409 41.5048C48.3188 41.6023 48.5367 41.6912 48.7948 41.7715C49.0587 41.8461 49.3799 41.8834 49.7585 41.8834ZM53.1401 42.9072V36.9447H57.1667V38.0718H54.4823V39.242H56.8655V40.3433H54.4823V41.7801H57.3646V42.9072H53.1401Z" fill="#144579"/>
                </svg>

              </div>
              <div class="avx-store-logo-nxt-cls">
                <h2 class="avx-store-title">Autoverse Store</h2>
                <p class="avx-store-subtitle">The perfect blend Quality and Reliability</p>
              </div>
            </div>

            <div class="avx-store-categories">
            
              <div class="avx-store-cat-card"><img src="../../../../assets/images/autoverse-sec-img/atv-sec-combined-img.png"></div>
            </div>
          </div>
          <div class="autoverse-slider-wrapper">
            <div class="autoverse-slider">

              <button class="avx-scroll-btn left" (click)="scrollProductsLeft()"><mat-icon class="key-brd-ryt">keyboard_arrow_left</mat-icon></button>

                <button class="avx-scroll-btn right" (click)="scrollProductsRight()"><mat-icon class="key-brd-ryt">keyboard_arrow_right</mat-icon></button>

              <div class="avx-store-products" #productScroller>
                <div class="avx-store-product-card" *ngFor="let product of brandSparesList; let i = index" >

                  <span 
                    *ngIf="product.discount > 0"
                    class="avx-store-discount-badge">
                    {{ product.discount }}% off
                  </span>
                  <div class="avx-store-product-image" [routerLink]="['/product-details/key/', product.key]"    style="cursor: pointer;">
                    <!-- <img [src]="product.imageUrl || 'assets/images/default-product.png'" alt="{{ product.name }}"> -->
                    <img [src]="product.imageUrl || 'assets/images/default-product.png'" alt="Product Image" onerror="this.src='assets/images/logos/logo.png'; this.classList.add('fallback-logo')">
                  </div>

                  <h3 class="avx-store-product-name">
                    {{ product.name }}
                  </h3>

                  <p class="avx-store-product-size" *ngIf="product.unit && product.unitType">
                    {{ product.unit }} {{ product.unitType }}
                  </p>

                  <div class="avx-store-price-row">
                    <p class="avx-store-mrp" *ngIf="product.mrp !== null && product.mrp !== undefined">
                      MRP ₹{{ product.mrp }}
                    </p>

                    <span class="avx-store-price" *ngIf="product.sellingPrice !== null && product.sellingPrice !== undefined">
                      ₹{{ product.sellingPrice }}
                    </span>

                    <span class="avx-store-save"
                          *ngIf="product.mrp && product.sellingPrice && product.mrp > product.sellingPrice">
                      Save ₹{{ product.mrp - product.sellingPrice | number:'1.2-2' }}
                    </span>
                  </div>

                  <div class="spare-add-cart">

                    <button
                      class="avx-store-cart-btn"
                      *ngIf="cartList.length <= 0 || (cartList[0] && !cartList[0][product.key])"
                      (click)="addCart(product, 1)">
                      Add to Cart
                    </button>

                    <div class="addtocartcompatiblecar1" *ngIf="cartList[0] && cartList[0][product.key]">
                      <div class="spare-add-cart1">
                        <div class="btn-group"
                            style="background:white;border-radius:6px;border:2px solid #144579; align-items: center;    justify-content: space-around; display: flex;"
                            *ngIf="product.key == cartList[0][product.key].key && cartList[0][product.key].cart_qty > 0">

                          <button class="button1" mat-raised-button
                                  (click)="removeItem(cartList[0][product.key].cart_qty, product.key)"
                                  style="min-width:8px;box-shadow:none;border:none;background:none;">
                            <mat-icon class="rmv">remove</mat-icon>
                          </button>

                          <input type="text"
                                [(ngModel)]="cartList[0][product.key].cart_qty"
                                readonly
                                class="rmv-inpt">

                          <button class="button1" mat-raised-button
                                  (click)="addItem(cartList[0][product.key].cart_qty, product.key)"
                                  style="min-width:8px;box-shadow:none;border:none;background:none;">
                            <mat-icon class="rmv">add</mat-icon>
                          </button>

                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            <div class="avx-store-footer" >
              <button 
                class="avx-store-explore-btn"
                (click)="openAutoverseStore()">
                Explore Autoverse Store 
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
            </div>
          </div>
        </div>

        <!-- SERVICE KIT SECTION -->
        <div class="avx-servicekit-section">

          <div class="avx-servicekit-header">
            <div class="header-left">
              <h2>Service kits</h2>
              <span>Buy our all in one service kits</span>

              <div class="header-tags">
                <span *ngFor="let item of kitItems">
                  {{ item }}
                </span>
              </div>

            </div>

            <div class="header-image" >
              <img src="../../../../assets/images/service-kit-img/ser-kit-prd-dtl-img.jpeg" alt="Service kit products">
            </div>
          </div>

          <div class="avx-slider-container">
            <div class="avx-slider-wrapper">

              <button class="scroll-arrow left" (click)="scrollServiceLeft()">
                &#10094;
              </button>

              <div class="avx-servicekit-slider" #slider>
                <div class="avx-servicekit-card"
                    *ngFor="let kit of serviceKitList">

                  <div class="card-header">

                    <div class="discount-badge"
                        *ngIf="kit.discount">
                      UP TO {{ kit.discount | number:'1.0-0' }}% OFF
                    </div>

                    <div class="car-images" (click)="openVehiclePopup()" style="cursor: pointer;">
                      <img [src]="kit.iconUrl" alt="Kit Image">
                    </div>

                    <div class="service-time">
                      ⏱ {{ kit.deliveryTime }}
                    </div>

                  </div>

                  <div class="card-body">
                    <div class="service-title">Service kit for</div>
                    <div class="product-name">{{ kit.title }}</div>
                  </div>

                </div>
              </div>
              <button class="scroll-arrow right" (click)="scrollServiceRight()">
                &#10095;
              </button>

            </div>
          </div>

          <div class="see-all-wrapper">
            <button class="see-all-btn"
                    (click)="openVehiclePopup()">
              See all service kits 
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>

        </div>

        <!-- SUMMER ESSENTIALS SECTION -->
        <div class="sx-summer-section">
          <div class="sx-summer-card">

            <img
              src="../../../../assets/images/summer-sec-img/Summer.png"
              alt="Summer Background"
              class="sx-bg-image"
            />

            <div class="sx-summer-header">
              <h2>Summer Must-Haves</h2>
              <p>
                Chill Out with Your Favourite Drink While We
                Handle Your Autopart Needs!
              </p>
            </div>

            <div class="sx-summer-grid">

              <div class="sx-summer-item"  (click)="acGas()">
                <h3>AC Gas</h3>
                <div class="sx-img-wrap">
                  <img src="../../../../assets/images/summer-sec-img/ac-gas-img.png" />
                </div>
              </div>

              <div class="sx-summer-item" (click)="airFilter()">
                <h3>Air Filter</h3>
                <div class="sx-img-wrap">
                  <img src="../../../../assets/images/summer-sec-img/air-fltr-img.png" />
                </div>
              </div>

              <div class="sx-summer-item" (click)="acFilter()">
                <h3>AC Filter</h3>
                <div class="sx-img-wrap">
                  <img src="../../../../assets/images/summer-sec-img/ac-fltr-img.png" />
                </div>
              </div>

              <div class="sx-summer-item"(click)="essentialFluids()">
                <h3>Essential Fluids</h3>
                <div class="sx-img-wrap">
                  <img src="../../../../assets/images/summer-sec-img/essential-fluids-img.png" />
                </div>
              </div>

              <div class="sx-summer-item"(click)="wiperBlades()">
                <h3>Wiper Blades</h3>
                <div class="sx-img-wrap">
                  <img src="../../../../assets/images/summer-sec-img/wiper-bld-img.png" />
                </div>
              </div>

              <div class="sx-summer-item" (click)="windshieldWasherFluid()">
                <h3>Windshield Washer Fluid</h3>
                <div class="sx-img-wrap">
                  <img src="../../../../assets/images/summer-sec-img/windshld-wshr-img.png" />
                </div>
              </div>

            </div>

          </div>
        </div>

        <!-- MARUTI GENUINE SECTION -->
        <div class="ms-genuine-section">

          <div class="ms-genuine-card">

            <!-- Header Area -->
            <div class="ms-genuine-header">
              <div class="ms-text">
                <h1 class="ms-subtitle"> <strong>GENUINE PARTS OF</strong></h1>
                <h2>{{ selectedBrand?.brandName }}</h2>
              </div>

              <div class="ms-car-image">
                <img src="../../../../assets/images/service-kit-img/image.png" alt="Car">
              </div>
            </div>

            <!-- Category Wrapper -->
            <div class="ms-category-wrapper">

              <!-- Left Arrow -->
              <div class="ms-scroll-arrow ms-left-arrow" (click)="scrollGenuineLeft()">
                &#10094;
              </div>

              <!-- Scrollable Row -->
              <div class="ms-category-row" #msCategoryRow>

                <!-- Optional Static Service Kit -->
                <div class="ms-category-item" (click)="openVehiclePopup()">
                  <h3>Service Kit</h3>
                  <div class="ms-img-box">
                    <img src="../../../../assets/images/service-kit-img/ser-kit-prd-dtl-img.jpeg" />
                  </div>
                </div>

                <!-- ✅ Dynamic Parts From API -->
                <div 
                  class="ms-category-item"
                  *ngFor="let part of selectedBrand?.parts"
                  (click)="selectGenuinePart(part.partName)">

                  <h3>{{ part.partName }}</h3>

                  <div class="ms-img-box">
                    <img 
                      [src]="part.imageUrl" 
                      [alt]="part.partName" />
                  </div>

                </div>

              </div>

              <!-- Right Arrow -->
              <div class="ms-scroll-arrow ms-right-arrow" (click)="scrollGenuineRight()">
                &#10095;
              </div>

            </div>

            <!-- Dots -->
            <!-- <div class="ms-slider-dots">
              <span 
                *ngFor="let dot of msDotsArray; let i = index"
                [class.active]="i === msActiveDotIndex">
              </span>
            </div> -->

          </div>

        </div>

      </div>
     <!-- INSURANCE SIDEBAR -->
  <div class="overlay" [class.visible]="isInsurance" (click)="goBackList()" *ngIf="isInsurance && !isMobile"></div>
  <div class="sidebar-container" *ngIf="isInsurance">
    <div class="create-req">
      <div *ngIf="!openEdit"><i (click)="goBackList()" >arrow_back</i>
        Create Request
      </div>
      <div *ngIf="openEdit"><i (click)="goBackList()" >arrow_back</i>
        Update Request Type
      </div>
      <div class="info" (click)="showPopup()">
        ?
      </div>
    </div>
    
    <div class="overflow">
    <h3 class="choose">Choose Request Type</h3>

    <div class="options">
      <div class="card" [ngClass]="{active: selectedType === 'insurance'}"
          (click)="selectType('insurance')">
        <div class="icon">🛡️</div>
        <div>
          <h4>Insurance</h4>
          <p>For insurance claims with insurer billing</p>
        </div>
      </div>

      <div class="card" [ngClass]="{active: selectedType === 'non-insurance'}"
          (click)="selectType('non-insurance')">
        <div class="icon">🧾</div>
        <div>
          <h4>Non-Insurance</h4>
          <p>For retail/regular jobs</p>
        </div>
      </div>
    </div>

    <div class="insurance-section" *ngIf="selectedType === 'insurance' && insurance.length>1">
    <h4 class="subtitle">Select Insurance Company</h4>
    <input
      type="text"
      class="search-box"
      placeholder="Search insurer (e.g., ICICI, HDFC)"
      [(ngModel)]="searchText"
      (ngModelChange)="onSearchChange()"
    />

    <div class="company-grid">
      <div
        class="company-card"
        *ngFor="let company of filteredList"
        (click)="selectCompany(company)"
        [ngClass]="{ selected: selectedCompany === company.insuranceGarageKey }"
      >
        <!-- <div class="circle"></div> -->
        <p>{{ company.insuranceGarageName }}</p>
      </div>
    </div>
  </div>

  </div>

  <div class="error-div">
        <p class="error" *ngIf="showError">
      Please choose Insurance or Non-Insurance.
    </p>     
    <p class="error" *ngIf="showError1">
      Please select an insurance company.
    </p>
    <div class="actions" *ngIf="openEdit">
      <button class="primary-btn"
          [class.active]="isContinueActive"
          (click)="updateInsurance()" style="width: 97%;">
        Update
      </button>

    </div>
    <div class="actions" *ngIf="!openEdit">
      <button class="secondary-btn" (click)="skip()">Skip & decide later</button>
      <button class="primary-btn"
          [class.active]="isContinueActive"
          (click)="continue()">
        Continue
      </button>

    </div>
    </div>
  </div>
<!-- = INSURANCE SIDEBAR END? -->
    </div>

  </div>

<div class="popup-overlay" *ngIf="showPopupinfo">
  <div class="popup-box">
    <h3>Which option to choose?</h3>
    <p>
      <strong>Insurance:</strong><br>
      If work is under insurance claim. We'll bill the insurer.
    </p>
    <p>
      <strong>Non-Insurance:</strong><br>
      For regular/retail jobs. We'll bill the garage.
    </p>
    <button (click)="closePopup()">Got it</button>
  </div>
</div>
    <!-- =============cart shared popup======= -->
<!-- <div class="popup-overlay" *ngIf="showSharedWtemPopup">
  <div class="popup-container">
    <div class="close-h3">
        <mat-icon class="close-icon" (click)="closeSharedWtemPopup()">close</mat-icon>
        <h3 class="popup-title">Cart items shared with you!</h3>
    </div>
    <div class="popup-content">
  <div class="item-card" *ngFor="let item of cartItems">
    <div class="offer-tag" *ngIf="item.discount > 0 && item.mrp > 0">
      {{ ((item.discount / item.mrp) * 100).toFixed(0) }}% off
    </div>

    <img [src]="item.imageUrl || 'assets/images/logos/logo.png'" class="item-image" alt="item image" />

    <div class="item-info">
      <div class="item-title">{{ item.name }}</div>
      <div class="item-units">{{ item.cartQty || 1 }} Units</div>
        <div class="item-brand" *ngIf="item.brandName">{{ item.brandName }}</div>
      <div class="item-part">{{ item.partNumber }}</div>

      <div class="item-price" *ngIf="item.discount > 0; else noDiscount">
        <span class="selling-price">₹{{ item.sellingPrice | number:'1.2-2' }}</span>
        <span class="mrp-price">₹{{ item.mrp | number:'1.2-2' }}</span>
        <div class="discount-price">You save ₹{{ item.discount | number:'1.2-2' }}</div>
      </div>

      <ng-template #noDiscount>
        <div class="item-price">
          ₹{{ item.mrp | number:'1.2-2' }}
        </div>
      </ng-template>

    </div>
  </div>
</div>

       <div class="popup-actions">
      <button class="add-to-cart-btn" (click)="addSharedCartToLocalCart()">Add To Cart</button>
      <button class="cancel-btn" (click)="closeSharedWtemPopup()">Cancel</button>
    </div>
   
  </div>
</div> -->

<app-asp-share-cart
  *ngIf="showSharedWtemPopup"
  [cartItems]="cartItems"
  [sharedCartKey]="sharedCartKey"
  (close)="showSharedWtemPopup = false">
</app-asp-share-cart>




<div #dynamicContainer></div>
<div #garageSelected></div>
<div #toolbarRef></div>
<div #intstantorder></div>

<button class="whatsapp-floater" (click)="openWhatsApp()">
  <img src="../../../../assets/images/whats-app-icon/whats-app-icon-image.png" alt="WhatsApp Chat" />
</button>

<app-asp-reg-dec-popup
  *ngIf="isVehiclePopupOpen"
  (close)="closeVehiclePopup()">
</app-asp-reg-dec-popup>


